import React from 'react'
import styled from 'styled-components'
import { Spacings, Text } from '@styles'

const Container = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_1B};
`

const CheckboxWrapper = styled.span`
	height: ${({ size }) => (size === '1' ? Spacings.SPACING_4B : size ? `${size}rem` : Spacings.SPACING_5B)};
	width: ${({ size }) => (size === '1' ? Spacings.SPACING_4B : size ? `${size}rem` : Spacings.SPACING_5B)};
	display: inline-flex;
	justify-content: center;
	align-items: center;
	position: relative;
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	pointer-events: ${({ readOnly }) => (readOnly ? 'none' : 'auto')};
	border-radius: ${({ theme }) => theme.radius.sm};
	background: ${({ checked, disabled, theme }) =>
		checked
			? theme.colors.brand.primary
			: disabled
				? theme.colors.border.default
				: theme.colors.surface.card};
	border: 1.5px solid ${({ checked, disabled, theme }) =>
		checked
			? theme.colors.brand.primary
			: disabled
				? theme.colors.border.default
				: theme.colors.border.strong};
	transition: all 0.2s ease-in-out;
	flex-shrink: 0;

	&:hover {
		border-color: ${({ checked, disabled, theme }) => 
			!disabled && !checked && theme.colors.border.focus};
		box-shadow: ${({ checked, disabled, theme }) => 
			!disabled && !checked && `0 0 0 3px ${theme.colors.brand.subtle}`};
	}

	& > input {
		top: 0;
		left: 0;
		width: 100%;
		cursor: inherit;
		height: 100%;
		margin: 0;
		opacity: 0;
		padding: 0;
		z-index: 1;
		position: absolute;
	}

	& > svg {
		height: 80%;
		width: 80%;
		transition: transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
		transform: scale(${({ checked }) => (checked ? 1 : 0)});
		flex-shrink: 0;
		user-select: none;
		fill: ${({ theme, checked }) => (checked ? theme.colors.text.inverse : theme.colors.text.disabled)};
	}
`

const LabelText = styled.label`
	font-size: ${Text.SMALL};
	color: ${({ theme }) => theme.colors.text.primary};
	font-weight: ${Text.BOLD_500};
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	pointer-events: ${({ readOnly }) => (readOnly ? 'none' : 'auto')};
	user-select: none;
`

const Checkbox = ({ id, size, value, checked, onChange, disabled, readOnly, title = '', label, onClick = () => {} }) => {
	const checkboxElement = (
		<CheckboxWrapper size={size} checked={checked} disabled={disabled} readOnly={readOnly}>
			<input 
				type="checkbox" 
				id={id} 
				value={value} 
				checked={checked} 
				disabled={disabled || readOnly} 
				onChange={onChange} 
				onClick={onClick} 
				title={title} 
			/>
			<svg focusable="false" viewBox="0 0 24 24">
				<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
			</svg>
		</CheckboxWrapper>
	)

	if (!label) {
		return checkboxElement
	}

	return (
		<Container>
			{checkboxElement}
			<LabelText htmlFor={id} disabled={disabled} readOnly={readOnly}>
				{label}
			</LabelText>
		</Container>
	)
}

export default Checkbox
